import { OrderApi } from '@/modules/server-api/commodity-sys/order';
import { $busErrorCode } from '@/modules/commodity-sys/common.js';

export default {
  data() {
    return {
      orderUnitList:['箱', '盒'],
      // 订单状态列表
      orderStatusList: [],
      orderWayList: [],
      //发货库存商品表格
      stockColumns:[
        {
          code: 'barCode',
          name: '69码',
          width: 130
        },
        {
          code: 'skuName',
          name: '商品名称',
          width: 230
        },
        {
          code: 'orderAmount',
          name: '下单数量',
          width: 150
        },
        {
          code: 'newSendSkuName',
          name: '发货商品',
          width: 270
        },
        {
          code: 'newSendAmount',
          name: '发货数量',
          width: 90
        },
        {
          code: 'actualAmount',
          name: '当前库存',
          width: 100
        },
        {
          code: 'actualAmountEnd',
          name: '发货后库存',
          width: 90
        }
      ]
    }
  },
  methods: {
    async getOrderWayList() {
      let res = await OrderApi.ChannelList({});
      console.log('res',res)
      this.orderWayList = res.result.map(item => {
        return {
          value: item.key,
          label: item.val
        }
      });
      
    },
    //订单状态列表
    async getStatusList() {
      let res = await OrderApi.StateList({});
      this.orderStatusList = res.result.map(item => {
        return {
          value: item.key,
          label: item.val
        }
      });
    },
    columnSpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log('row, column, rowIndex, coorderStatusListlumnIndex ',row, column, rowIndex, columnIndex )
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
        // console.log('2333',row, column)
        if(row.split) {
          if(row.split === 1) {
            return {
              rowspan: 2,
              colspan: 1
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        } else {
          // console.log(34333)
          return {
            rowspan: 1,
            colspan: 1
          };
        }
      }
    },

    //根据仓位查询商品库存
    async queryStockData(){
      this.$vs.loading();
      let res = await OrderApi.skuSendStocks({
        // skuCodes: this.skuCodes,
        orderNos:this.verifyConfirmId,
        locId: this.deliverParam.locId
      });
      if (res.succ == 1 && res.code != $busErrorCode) {
        let resData = res.result || [];
        this.deliverFlag = true;
        if(resData.length > 0){
          this.stockTabledata = [];
          //修改为只从返回的resData
          resData.map((item,stockIndex) => {
            //当前库存
            item.newSendAmount = item.sendAmount;
            item.newSendSkuName = `${item.sendSkuName} \n ${item.sendBarCode}`;
              if(item.deliveryFlag){
                item.tdClass = 'text-success';
                item.remark = '';
              }else{
                item.tdClass = 'text-danger';
                item.remark = '当前仓库库存不足';
                //不可以发货
                this.deliverFlag=false;
              }
              //寻找是否有对应的另一个规格
              let existsMore = false;
              resData.map((stock,idx) => {
                if(stock.skuCode == item.skuCode && stock.sendSkuCode != item.sendSkuCode){
                  existsMore = true;
                }
              })
              //是否已存在数据中：排序
              let inTable = false;
              if(this.stockTabledata.length > 0){
                let arr = this.stockTabledata.filter(data => data.skuCode == item.skuCode);
                inTable = arr.length == 0 ? false : true;
              }
              if(existsMore){
                item.split = inTable ? 2 : 1;
              }else{
                item.split = 0;
              }
              this.stockTabledata.push(item);
          })
          // this.stockData.map((item,stockIndex) => {
          //   //是列表页 item    库存值 resData sku
          //   // let existsSku = resData.filter(sku => sku.skuCode == item.sendSkuCode);
          //   let existsSku = resData.filter(sku => sku.sendSkuCode == item.sendSkuCode);
          //   console.log('existsSku===>', item, existsSku);
          //   if(existsSku.length > 0){
          //     //当前库存
          //     item.actualAmount = existsSku[0].actualAmount || 0;
          //     item.actualAmountEnd = existsSku[0].actualAmountEnd
          //     item.newSendAmount = existsSku[0].sendAmount

          //     if(existsSku[0].deliveryFlag){
          //       item.tdClass = 'text-success';
          //       item.remark = '';
          //     }else{
          //       item.tdClass = 'text-danger';
          //       item.remark = '当前仓库库存不足';
          //       //不可以发货
          //       this.deliverFlag=false;
          //     }
              
          //     //隐藏没有发货数量的商品
          //     //寻找是否有对应的另一个规格
          //     let existsMore = false;
          //     // this.stockData.map((stock,idx) => {
          //     resData.map((stock,idx) => {
          //       // if(stock.barCode == item.barCode && stock.sendBarCode != item.barCode){
          //       if(stock.skuCode == item.skuCode && stock.sendSkuCode != item.sendSkuCode){
          //         existsMore = true;
          //       }
          //     })
          //     //是否已存在数据中：排序
          //     let inTable = false;
          //     if(this.stockTabledata.length > 0){
          //       // let arr = this.stockTabledata.filter(data => data.skuCode == item.sendSkuCode);
          //       let arr = this.stockTabledata.filter(data => data.skuCode == item.skuCode);
          //       inTable = arr.length == 0 ? false : true;
          //     }
          //     if(existsMore){
          //       item.split = inTable ? 2 : 1;
          //     }else{
          //       item.split = 0;
          //     }
          //     this.stockTabledata.push(item);   
          //   }  
          // })
          this.$vs.loading.close();
        }
      } else {
        this.$vs.loading.close();
        this.$notifyError(res.error);
      }
    },
    tableRowClassName({row, rowIndex}) {
      console.log('row===>', row);
      return row.tdClass
      // if (rowIndex === 1) {
      //   return 'warning-row';
      // } else if (rowIndex === 3) {
      //   return 'success-row';
      // }
    }
  },
  watch: {
    "deliverParam.locId"(val, oldVal){
      //加载当前库存
      if(val && val != ''){
        this.stockData.forEach(item => {
            item.newSendSkuName = `${item.sendSkuName} \n ${item.sendBarCode}`
        })
        console.log('2323232===>', 2323232);
        
        this.queryStockData();
      }
    }
  },
}